import { render, staticRenderFns } from "./imgCropper.vue?vue&type=template&id=0f8982a3&scoped=true"
import script from "./imgCropper.vue?vue&type=script&lang=js"
export * from "./imgCropper.vue?vue&type=script&lang=js"
import style0 from "./imgCropper.vue?vue&type=style&index=0&id=0f8982a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8982a3",
  null
  
)

export default component.exports